import React, { useState } from 'react';
import { PlanRowWrapper, PlanWrapper } from '../UI/styledConstants';

function Plan({ planDetails, selectPlan = () => {}, plan = '',serverType,circle }) {
	const [activePlan, setActivePlan] = useState('talktime');
	const plan_ = Object.values(planDetails);
	let planList = plan_.filter(item => item.status === "ACTIVE");
	let header = [];
   if(serverType === "Mobile Prepaid"){
	planList = planList.filter(item =>item.planAdditionalInfo?.tag?.some(tag => (tag.paramName === "Circle") && (tag.paramValue === circle)) );
	if(planList?.[0]){
		header = planList[0]?.planAdditionalInfo?.tag.map((item) => item.paramName);
	}
	header.push("Description");
	header.push("Price");
	header?.shift();
   }
   

	
	return (
		<PlanWrapper>
			<div className="plan-tabs-wrapper ">
				{/* {Object.keys(planDetails).map((key, i) => (
					<div key={i} className={`${activePlan === key ? 'active' : ''} plan-tab`} onClick={() => setActivePlan(key)}>
						{key}
					</div>
				))} */}
			</div>
			{/* <div className='planWrapper'>
			<table>
			<thead>
				<tr>
				{
					header && header.map((val,i) =>{
						return(
							<th key={i}>{val}</th>
						)
					})
				}
				
				</tr>

				</thead>
				<tbody>
				{
					planList && planList.map((val,i) =>{
						const preFixedData = ['Talktime'];
	const days = ['Validity'];
						return(
							<tr>

							{
								val.planAdditionalInfo?.tag && val.planAdditionalInfo?.tag.map((tags, index) =>{
									if(tags.paramName === "Type"){
										return "";
									}
									 let preFix = "";
									 let postFix = ""
									 if(preFixedData.includes(tags?.paramName)){
										preFix = '₹';
									 }
									 if(days.includes(tags?.paramName)){
										postFix = ' Days';
									 }
									return(
									<td key={index}>
										{preFix+tags?.paramValue+postFix}
									</td>
									)

								})
							}
							<td className='desc'>{val?.planDescription}</td>
							<td>₹{val?.amountInRupees}</td>
						  </tr>
						)
					})
				}
				</tbody>
			  </table>
			</div> */}
		 <RowBox list={planList} handleFormPlan={selectPlan} selectData={plan} /> 
		</PlanWrapper>
	);
}

export default Plan;

const RowBox = ({ list = [], handleFormPlan = () => {}, selectData = null}) => {
	const preFixedData = ['Talktime'];
	const days = ['Validity'];
	return (
		<PlanRowWrapper>
			
			{list &&
				list.map((data, i) => {

					return (
						<div className="planRow" key={i}>
							
								      <>
									  <div className="valueBox">
								         <div className="title">Amount</div>
										 <div className="value"> ₹{data?.amountInRupees}</div>
						         	</div>
									 <div className="valueBox" >
									 <div className="title">Description</div>
								       <div className="value"> {data?.planDescription}</div>
								         
						         	</div>
									  </>
						         	
							  {
                               data?.planAdditionalInfo?.tag.map((tags, index) =>{
                                if(tags.paramName === "Type"){
                                    return "";
                                }
								 let preFix = "";
								 let postFix = ""
								 if(preFixedData.includes(tags?.paramName)){
									preFix = '₹';
								 }
								 if(days.includes(tags?.paramName)){
									postFix = ' Days';
								 }
                                  return(
                                    <div className="valueBox" key={index}>
										 <div className="title">{tags?.paramName}</div>
								       <div className="value"> {preFix+tags?.paramValue+postFix}</div>
								        
						         	</div>
							
							
                                  )
                               })
                            }  
                            <div className="valueBox center">
								<button className={selectData === data.rs ? 'active' : ''} onClick={() => handleFormPlan(data)}>
									Apply
								</button>
							</div>
						</div>
					);
				})}
		</PlanRowWrapper>
	);
};
